import { GET_REPORT_DATA, GET_CONFERENCIAS, GET_DADOS_CHAMADA } from './mutation-types'

export default {
  [GET_REPORT_DATA]: (state, dadosRelatorio) => {
    state.dadosRelatorio = dadosRelatorio
  },
  [GET_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [GET_DADOS_CHAMADA]: (state, dadosChamada) => {
    state.dadosChamada = dadosChamada
  },
}
